import { OEButton, OEText, width } from '@openeducation/oe-it-components';
import {
  dateArrayToString,
  FeedbackResponseDTO,
} from '@openeducation/oe-it-services';
import { styled } from '@openeducation/oe-it-themes';
import * as React from 'react';
import { ScrollView, Text, View } from 'react-native';

import { PCFeedbackCardLessonTitle } from '../pc-feedback-card/pc-feedback-card-lesson-title';

export interface FeedbackContentModalProps {
  feedback: FeedbackResponseDTO;
  onGotItPress: () => void;
}

export const FeedbackContentModal = ({
  feedback,
  onGotItPress,
}: FeedbackContentModalProps) => {
  return (
    <View>
      <TitleView>
        <PCFeedbackCardLessonTitle lessonName={feedback.lessonName} />
        <Text>{dateArrayToString(feedback.dateOfClass, 'MMM, dd yyyy')}</Text>
      </TitleView>
      <CommentView>
        <ScrollView>
          <OEText>{feedback.teacherFeedback}</OEText>
        </ScrollView>
      </CommentView>
      <FooterView>
        <OEButton size="huge" style={[width(120)]} onPress={onGotItPress}>
          Got it!
        </OEButton>
      </FooterView>
    </View>
  );
};

const TitleView = styled.View`
  height: 115px;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 32px;
`;
const CommentView = styled.View`
  padding-top: 24px;
  padding-bottom: 24px;
  background-color: ${({ theme }) => theme.color.lightPrimary};
  padding-left: 32px;
  max-height: 270px;
  padding-right: 16px;
`;

const FooterView = styled.View`
  height: 88px;
  padding-top: 24px;
  padding-bottom: 24px;
  justify-content: center;
  align-items: center;
`;

export default FeedbackContentModal;
